import type { AnswerFragment } from '../../../present/activity-answers.graphql.generated';
import { isRichtextValueEmpty } from './get-richtext-value';
import { getRichtextAnswer } from './get-richtext-answer';

export function hasTextAnswer(
  answer: AnswerFragment | null | undefined
): boolean {
  return !isRichtextValueEmpty(getRichtextAnswer(answer));
}
